import { computed, ref } from 'vue';
import { useContactFormStore } from '../store/contactFormStore';
import { ICountryItem } from '../utils/interfaces';

const getCountryNameList = (countryItems: ICountryItem[]): string[] => {
  return countryItems.map(countryItem => countryItem.countryName);
}

export const useCountrySelection = () => {
  const contactFormStore = useContactFormStore();
  const currentCountry = ref<string>('');

  const countryNameList = computed(() => getCountryNameList(contactFormStore.getCountryItems ?? []));
  const countrySelectionMade = computed(() => currentCountry.value !== '');
  const selectedCountryItem = computed(() => {
    const items = contactFormStore.getCountryItems ?? [];
    return items.find(item => item.countryName === currentCountry.value) ?? null;
  });

  return { currentCountry, countrySelectionMade, countryNameList, selectedCountryItem };
};
